module.exports = __webpack_public_path__ + "static/media/Punjab Public library c. 1870.9c2646e0.jpeg";